module.exports = __webpack_public_path__ + "img/rio-21.c5a6789c.png";